import React from "react";
import ReactEcharts from "echarts-for-react";

// import { getData } from "service/GenericData";
import Styles from "components/VOCVOIProgressionChart/ProgressionChartBase.module.css";
import { getVOCVOIProgressionChartAxisLabels } from "service/textRetrieval";
// import { CSVLink } from "react-csv";
import { scaleLinear} from "d3-scale";

const StackedAreaChartBase = ({
  textLiterals,
  avgValueLabel,
  avgValueKey,
  variantsColorsMap,
  data,
  isLoading,
  city
}) => {

  // colorPalette=scaleLinear().clamp(true).domain([1, pulseCountries.length]).range(["#ff3c19", "#4d302b"])
//   const colorstmp=[ 

//     '#E37474',
//     '#E374A1',
//     '#D678C7',
//     '#DD79ED',
//     '#BA73E6',

//     '#789FE3',
//     '#78B7E3',
//     '#7DC5D6',
//     '#7EEDE8',
//     '#77E6C6',

//     '#54E384',
//     '#54E35C',
//     '#7DD659',
//     '#B6ED58',
//     '#E0E354',

//     '#E3C354',
//     '#E3B454',
//     '#D6A15A',
//     '#ED9758',
//     '#E37B54',

//     /* H:range 20  S:35 B:89 */
//     '#E3978D',
//     '#E38D94',
//     '#D68FB8',
//     '#E993ED',
//     '#C88DE3',

//     '#B88FE3',
//     '#A28FE3',
//     '#9195D6',
//     '#95B1ED',
//     '#8FBFE3'
//  ]
  // const [isLoading, setIsLoading] = React.useState(true);
  // const monthNameList = ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
  // Update Line Graph settings based on scale
  const [width, setWidth] = React.useState(window.innerWidth);
  const [isSmallScreen, setIsSmallScreen] = React.useState(width < 1200);
  const csvLink = React.useRef();
  const updateDimensions = () => {
    setWidth(window.innerWidth);
    setIsSmallScreen(window.innerWidth < 1200);
  };
  React.useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  // Polling data
  const [yAxisLabel, setYAxisLabel] = React.useState("");
  const [xAxisLabel, setXAxisLabel] = React.useState("");
  // const [data, setData] = React.useState([]);
  const dataStartingIndex = 0;
  // let [delay, setDelay] = React.useState(5000); // 5 seconds
  React.useEffect(() => {
    // setIsLoading(true);
    setXAxisLabel(getVOCVOIProgressionChartAxisLabels(textLiterals)[0]);
    setYAxisLabel(getVOCVOIProgressionChartAxisLabels(textLiterals)[1]);
    // getData(`vocvoi_progression_chart`).then((result) => {
    //     if (result != null) {
    //       setData(parseResult(result[0].countryData)); // the first result is for All
    //       setIsLoading(false);
    //       // setDelay(null);
    //     }
    //     else {
    //       setIsLoading(true);
    //     }
    //   });
    // setIsLoading(false);
    
  }, [textLiterals]);

  // const fiveMinutes = 1000 * 60 * 5; // in milliseconds
  // useInterval(() => {
  //     if (data == null || data.length === 0) {
  //         setIsLoading(true);
  //         getData(`stackedareachart`, sessionid).then((result) => {
  //             if (result == null) {
  //                 setIsLoading(true);
  //             } else {
  //                 setIsLoading(false);
  //                 setData(parseResult(result));
  //                 setDelay(null);
  //             }
  //         });
  //     } else {
  //         setDelay(null); // disbale the interval
  //     }
  // }, delay);
  function getDomainRange(numberOfColors, datalength) {
    if (numberOfColors > datalength)
      return [...Array(numberOfColors).keys()];
    else {
      let colorArray = [];
      colorArray.push(0);
      for (let i = 1; i < numberOfColors; i++) {
        colorArray.push(parseInt((datalength - 1) * i / (numberOfColors - 1)));
      }
      colorArray.push(datalength - 1);
      // console.debug(colorArray);
      return colorArray;
    }
  }

  function buildSeries(data) {
    const series = [];
    for (let i = 0; i < data.length; i++) {
      // let variant = (data[i] ?? {}).variant;
      let variantName = (data[i] ?? {}).vn;
      let color=scaleLinear().clamp(true).domain(getDomainRange(28,data.length)).range(['#1f77b4',
      '#aec7e8',
      '#ff7f0e',
      '#ffbb78',
      '#2ca02c',
      '#98df8a',
      '#ef6f6a',
      '#ff9896',
      '#9467bd','#c5b0d5','#8c564b','#c49c94','#e377c2','#f7b6d2','#bcbd22','#dbdb8d','#17becf','#9edae5','#8175aa','#6fb899',
    '#31a1b3','#ccb22b','#a39fc9','#94d0c0','#027b8e','#9f8f12','#7f7f7f','#c7c7c7'])(i)

      // ['#5470c6',
      // 'rgb(145,204,117)',
      // 'rgb(250, 200, 88)',
      // 'rgb(238, 102, 102)',
      // 'rgb(115, 192, 222)',
      // 'rgb(59, 162, 114)',
      // 'rgb(252, 132, 82)',
      // 'rgb(154, 96, 180)',
      // 'rgb(234, 124, 204)']

      // let color='none'
      series.push({
        name: variantName,
        type: "line",
        stack: avgValueKey, // y axis variable
        // areaStyle: { color: variantsColorsMap[variantName]===undefined?variantsColorsMap[variantName.split(" ")[0]]:variantsColorsMap[variantName],
        areaStyle: { color:color,opacity:1 },
        // areaStyle: { opacity:1 },
        // lineStyle: { color: variantsColors[variantName] },
        // lineStyle: { color: scaleLinear().clamp(true).domain([0, parseInt((data.length-1)/3),parseInt((data.length-1)*2/3),data.length-1]).range(["#F5595B","#5D5EF5", "#59F5A8","#F5E260"])(i) },
        lineStyle:{color:"none"},
        // symbol: "rect",
        symbolSize: "0",
        symbol: "roundRect",
        itemStyle: {
          color: color
        },
        // hoverAnimation: false,
        // emphasis: {
        //   focus: 'series'
        // },
        // label: {
        //   show: true
        // },
        xAxisIndex: 0,
        yAxisIndex: 0,
        datasetIndex: i,
        encode: {
          x: "ym",
          y: avgValueKey,
        },
      });
    }
    return series;
  }
  const legendValues = data.map((val) => val.vn);
  const series = buildSeries(data);
  const dataset = data
    .map((val) => val.md)
    .map((weeklyDataPerContinent) => {
      return {
        dimensions: [
          "ym",
          "p",
        ],
        source: weeklyDataPerContinent.slice(dataStartingIndex),
      };
    });
  // const colors= scaleLinear().clamp(true).domain([0, parseInt((data.length-1)/2),data.length-1]).range(["red","blue", "yellow"])
  // const csvdata = data.map(item => ({
  //   lineage: item.vn,
  //   month: item.md.map(monthlyData => monthlyData.ym),
  //   progression: item.md.map(monthlyData => monthlyData.p),
  // }))
  // console.log("series :>> ", series);
  const option = {
    legend: {
      data: legendValues,
      orient: "vertical",
      type: "scroll",
      top:  "4%" ,
      right: "0%",
      left: "85%",
      bottom:"5%",
      textStyle: {
        width:isSmallScreen? "140":"100",
        overflow: "break",
        fontSize: 10
      },
      tooltip: {
        show:false,
        trigger: "item",
        position: 'bottom',
        confine: true,
        formatter: function (params) {
          return params.name;
        }
      }
    },
    toolbox: {
      show: true,
      orient: 'horizontal',
      left: 'right',
      top: 'bottom',
      feature: {
        saveAsImage: {
          title: '保存为SVG文件',
          name: 'Progression',
          emphasis: {
            iconStyle: {
              textPosition: 'left',
              textFill: '#666',
              opacity: 1,
              textAlign:'right',
              textBackgroundColor: '#fff',
              textPadding: 3,
              textBorderRadius: 2
            }
          },
          type: 'svg'
        },
        // myTool1: {
        //   show: true,
        //   title: '下载过去3个月的TSV文件',
        //   icon: 'image://tsv.png',
        //   emphasis: {
        //     iconStyle: {
        //       textPosition: 'bottom',
        //       textFill: '#666',
        //       opacity: 1,
        //       textPadding: 3,
        //       textBorderRadius: 2
        //     }
        //   },
        //   onclick: function () {
        //     csvLink.current.click();
        //   }
        // }
      }
    },
    tooltip: {
      trigger: 'item',
      // axisPointer: {
      //   // type: "cross",
      //   // animation: false,
      //   label: {
      //     formatter: function formatter(params) {
      //       console.log(params);
      //       return `test`;
      //    },
      //   },
      // },
      textStyle:{
        color: '#fff'
      },
      backgroundColor: "rgba(50,50,50, 0.9)",
      // position: function (pos, params, el, elRect, size) {
      //   let obj = {};
      //   obj[["top", "bottom"][+(pos[1] < size.viewSize[1] / 2)]] = 10;
      //   obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
      //   return obj;
      // },
      formatter: function (params) {
        var tooltip = `<p>${params[0].name.substring(0, 4) + "年" + parseInt(params[0].name.substring(4)) + "月"} </p>`;
        tooltip += `<p class=${Styles.tooltip}>`
        var longest = params.reduce(
          function (a, b) {
            return a.seriesName.length > b.seriesName.length ? a : b;
          }
        );
        params = params.sort(function (a, b) {
          var keyA = a.data['p'],
            keyB = b.data['p'];
          // Compare the 2 dates
          if (keyA < keyB) return 1;
          if (keyA > keyB) return -1;
          return 0;
        });

        let count = 0
        tooltip += `占比前五位的谱系:<br/>`
        for (let param of params) {
          if (param.data['p'] > 0) {
            tooltip += `${param.marker} ${param.seriesName.padEnd(longest.seriesName.length, ' ')}&#9;:&#9;<b>${param.data['p']}</b>  <br/>`
            count++
            if (count >= 5) break
          }
        }
        tooltip += `</p>`;
        return tooltip;
      }
      // formatter: function (params) {
      //   // var dateEnd = new Date(
      //   //   (params ?? { data: { date: new Date() } }).data.date
      //   // );
      //   // dateEnd.setDate(dateEnd.getDate() + 6);
      //   var tooltip = `<p>For ${(params ?? { axisValueLabel: "" }).name
      //     } </p>`;
      //   tooltip += `<p class=${Styles.tooltip}>
      //       ${params.marker} ${params.seriesName}:<br/>
      //       ${avgValueLabel}: ${params.data[avgValueKey]}
      //       </p>`;
      //   return tooltip;
      // },
    },
    grid: [
      {
        left: isSmallScreen ? "10%":"7%",
        top: isSmallScreen ? "5%": "5%",
        bottom: "25%",
        right: "17%",
        containLabel: true
      },
    ],

    dataZoom: [
      {
        type: "inside",
        realtime: true,
        start: 0,
        end: 100,
        xAxisIndex: [0],
      },
      {
        type: "slider",
        show: true,
        realtime: true,
        start: 0,
        end: 100,
        top: "89%",
        handleIcon:
          "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
        handleSize: "80%",
        handleStyle: {
          color: "#fff",
          shadowBlur: 3,
          shadowColor: "rgba(0, 0, 0, 0.6)",
          shadowOffsetX: 2,
          shadowOffsetY: 2,
        },
      },
    ],
    xAxis: {
      name: xAxisLabel,
      nameLocation: "middle",
      nameTextStyle: {
        align: "center",
        verticalAlign: "top",
        padding: [10, 0, 0, 0],
      },
      gridIndex: 0,
      type: "category",
      boundaryGap: false,
      axisLabel:{
        formatter: function (value) { // 202001,202002
          // let monthName=monthNameList[parseInt(value.substring(4))-1];
          return value.substring(0,4)+"年"+parseInt(value.substring(4))+"月" ;
        }
      },
      axisTick:{
        intervel: 0
      },
      axisPointer: {
        show:true,
        label: {
          formatter: function (params) { // 202001,202002
            return params.value.substring(0,4)+"年"+parseInt(params.value.substring(4))+"月" ;
        },
      }
      },
    },
    yAxis: {
      name: yAxisLabel,
      gridIndex: 0,
      nameLocation: "middle",
      nameGap: 25,
      offset: -2,
      nameTextStyle: {
        padding: [0, 0, 15, 0],
      },
      axisLine:{
        show: true
      },
      max: 1,
      axisLabel:{
        formatter: function (value, index) {
          return (value * 100) + "%";
        }
      }
    },
    dataset: dataset,
    series: series,
    // color: colorstmp
  };

  return (
    <div>
      <ReactEcharts showLoading={isLoading} option={option}  opts={{ renderer: 'svg' }} notMerge={true} />
      <div className={Styles.download}>
        <a href="data/GISAID_China_lineagedetail_files.zip" download ref={csvLink}>
       </a>
      {/* <CSVLink
          data={csvdata}
          filename={"lineage_stacked_china_"+city+".csv"}
          target="_blank"
          ref={csvLink}
        >
          
        </CSVLink> */}
      </div>
    </div>
  );
};

export default StackedAreaChartBase;
